import React from 'react';
import {
  CalculatorIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  DocumentChartBarIcon,
  DocumentMagnifyingGlassIcon,
  TrophyIcon,
  SparklesIcon,
  PresentationChartLineIcon,
  ScaleIcon,
} from '@heroicons/react/24/outline';

type PageKey =
  | 'observatoireRoi'
  | 'bibliotheque'
  | 'ratio'
  | 'etudeOpportunite'
  | 'chiffrage'
  | 'performanceMarches'
  | 'meilleurFournisseur'
  | 'suiviProjets'
  | 'challengerDevis'
  | 'comparateur'
  | 'analyse-ao' // accessible via ?page=analyse-ao, volontairement masqué dans la nav
  | 'CTA'; // accessible via ?page=CTA, redirige hors SPA, jamais affiché dans la nav

interface NavigationProps {
  currentPage: PageKey;
  onPageChange: (page: PageKey) => void;
}

const Navigation: React.FC<NavigationProps> = ({ currentPage, onPageChange }) => {
  return (
    <nav className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex space-x-2 whitespace-nowrap overflow-x-auto">
          <button
            onClick={() => onPageChange('observatoireRoi')}
            className={`flex items-center space-x-2 py-5 px-3 border-b-2 font-medium text-sm transition-colors ${
              currentPage === 'observatoireRoi'
                ? 'border-violet-500 text-violet-700'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <PresentationChartLineIcon className="w-5 h-5" />
            <span>Observatoire ROI</span>
          </button>

          <button
            onClick={() => onPageChange('bibliotheque')}
            className={`flex items-center space-x-2 py-5 px-3 border-b-2 font-medium text-sm transition-colors ${
              currentPage === 'bibliotheque'
                ? 'border-violet-500 text-violet-700'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <CurrencyDollarIcon className="w-5 h-5" />
            <span>Bibliothèque de prix</span>
          </button>
          
          <button
            onClick={() => onPageChange('ratio')}
            className={`flex items-center space-x-2 py-5 px-3 border-b-2 font-medium text-sm transition-colors ${
              currentPage === 'ratio'
                ? 'border-violet-500 text-violet-700'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <ChartBarIcon className="w-5 h-5" />
            <span>Ratio projet</span>
          </button>
          
          <button
            onClick={() => onPageChange('etudeOpportunite')}
            className={`flex items-center space-x-2 py-5 px-3 border-b-2 font-medium text-sm transition-colors ${
              currentPage === 'etudeOpportunite'
                ? 'border-violet-500 text-violet-700'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <ScaleIcon className="w-5 h-5" />
            <span>Étude d'opportunité</span>
          </button>

          <button
            onClick={() => onPageChange('chiffrage')}
            className={`flex items-center space-x-2 py-5 px-3 border-b-2 font-medium text-sm transition-colors ${
              currentPage === 'chiffrage'
                ? 'border-violet-500 text-violet-700'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <CalculatorIcon className="w-5 h-5" />
            <span>Chiffrage</span>
          </button>

          <button
            onClick={() => onPageChange('challengerDevis')}
            className={`flex items-center space-x-2 py-5 px-3 border-b-2 font-medium text-sm transition-colors ${
              currentPage === 'challengerDevis'
                ? 'border-violet-500 text-violet-700'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <DocumentMagnifyingGlassIcon className="w-5 h-5" />
            <span>Challenger un devis</span>
          </button>

          <button
            onClick={() => onPageChange('suiviProjets')}
            className={`flex items-center space-x-2 py-5 px-3 border-b-2 font-medium text-sm transition-colors ${
              currentPage === 'suiviProjets'
                ? 'border-violet-500 text-violet-700'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <DocumentChartBarIcon className="w-5 h-5" />
            <span>Suivi des Projets</span>
          </button>

          <button
            onClick={() => onPageChange('meilleurFournisseur')}
            className={`flex items-center space-x-2 py-5 px-3 border-b-2 font-medium text-sm transition-colors ${
              currentPage === 'meilleurFournisseur'
                ? 'border-violet-500 text-violet-700'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <TrophyIcon className="w-5 h-5" />
            <span>Meilleur fournisseur</span>
          </button>

          <button
            onClick={() => onPageChange('performanceMarches')}
            className={`flex items-center space-x-2 py-5 px-3 border-b-2 font-medium text-sm transition-colors ${
              currentPage === 'performanceMarches'
                ? 'border-violet-500 text-violet-700'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <SparklesIcon className="w-5 h-5" />
            <span>Performance marchés</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation; 